var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7789 4.22185C19.3884 3.83132 18.7552 3.83132 18.3647 4.22185L12.0008 10.5858L5.63679 4.22185C5.24627 3.83132 4.61311 3.83132 4.22258 4.22185C3.83206 4.61237 3.83206 5.24554 4.22258 5.63606L10.5865 12L4.22258 18.364C3.83206 18.7545 3.83206 19.3877 4.22258 19.7782C4.61311 20.1687 5.24627 20.1687 5.63679 19.7782L12.0008 13.4142L18.3647 19.7782C18.7552 20.1687 19.3884 20.1687 19.7789 19.7782C20.1695 19.3877 20.1695 18.7545 19.7789 18.364L13.415 12L19.7789 5.63606C20.1695 5.24554 20.1695 4.61237 19.7789 4.22185Z",
    fill: "#241A0F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6c3e15c0f4b0223fae37df5a830f0028.svg";
export { ForwardRef as ReactComponent };